<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body m-article-container">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">报告信息管理</div>
          <span class="m-title-s">对报告信息新增、编辑、排序等操作</span>
        </div>
        <div class="m-new-title">最新报告 ></div>
        <div>
          <div class="m-new-item" v-for="item in newArticleList" :key="item.id">
            <span class="m-new-opt">{{ item.parentName }}</span>
            {{ item.title }}
            <span class="m-new-btn" @click="newArticleDel(item.id)">删除</span>
          </div>
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-article-box">
            <div v-for="(item, index) in dataListOpt" :key="index" :index="index" class="m-article-item"
            :class="item['id'] === form.homeOptionId ? 'm-article-selected' : ''"
            v-if="item['title'] !== '人气榜单' && item['title'] !== '创业医生'"
            @click="loadSelectedData(item['id'])">
              <div>{{ item['title'] }}</div>
            </div>
          </div>
          <div class="m-table-btn">
            <el-button @click="addArticle" type="primary">新增报告</el-button>
          </div>
        </el-container>
        <el-table
          :data="dataList"
          v-loading="isLoading"
          style="width: 100%;
          margin-bottom: 20px;"
          row-key="id"
          border
          size="small">
          <el-table-column prop="title" label="报告名称" width="230"></el-table-column>
          <el-table-column prop="status" label="状态" align="center" width="100">
            <template slot-scope="scope" v-if="scope.row.id.length > 1 && scope.row.homeOptionId != null">
              <el-tag v-if="scope.row.status === '1'">上线</el-tag>
              <el-tag type="danger" v-else>下线</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="sort" label="排序" align="center" width="50"></el-table-column>
          <el-table-column prop="createDate" label="创建时间" width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="updateDate" label="修改时间" width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="remarks" label="备注"></el-table-column>
          <el-table-column label="内容管理" width="90" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.id.length > 1 && scope.row.homeOptionId != null" type="primary" size="mini" @click="openArticleCont(scope.row.id)">内容</el-button>
            </template>
          </el-table-column>
          <el-table-column label="音频管理" width="180" align="center">
            <template slot-scope="scope">
              <!--       上传音频       -->
              <el-button v-if="scope.row.id.length > 1 && scope.row.homeOptionId != null && scope.row.audioState === '1'"
                         type="success" size="mini" @click="openArticleAudio(scope.row.id)">音频</el-button>
              <!--       设置是否有音频       -->
              <el-button v-if="scope.row.id.length > 1 && scope.row.homeOptionId != null && scope.row.audioState === '1'" plain
                         type="success" size="mini" @click="openAudioStateDialog(scope.row.id, scope.row.audioState)">有音频</el-button>
              <el-button v-if="scope.row.id.length > 1 && scope.row.homeOptionId != null && scope.row.audioState !== '1'"
                         type="danger" size="mini" @click="openAudioStateDialog(scope.row.id, scope.row.audioState)">无音频</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="falseMoney" label="折扣虚价" align="center">
            <template slot-scope="scope">
              <div style="color: #ff4d51;font-weight: bold;">{{ scope.row.falseMoney }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="iosFalseMoney" label="ios折扣虚价" align="center">
            <template slot-scope="scope">
              <div style="color: #ff4d51;font-weight: bold;">{{ scope.row.iosFalseMoney }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="falseMoneyStatus" label="虚价开关" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.falseMoneyStatus === '0'" type="info">关闭</el-tag>
              <el-tag v-else-if="scope.row.falseMoneyStatus === '1'" type="danger">开启</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="money" label="价格" align="center">
            <template slot-scope="scope">
              <div style="color: #ff4d51;font-weight: bold;">{{ scope.row.money }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="iosMoney" label="ios价格" align="center">
            <template slot-scope="scope">
              <div style="color: #ff4d51;font-weight: bold;">{{ scope.row.iosMoney }}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="210" align="center">
            <template slot-scope="scope" v-if="scope.row.id.length > 1 && scope.row.homeOptionId != null">
              <el-button type="primary" size="mini" @click="openForm(scope.row.id)" plain>编辑</el-button>
              <el-button type="danger" size="mini" @click="menuDel(scope.row.id, scope.row.title)" plain>删除</el-button>
              <el-button type="success" size="mini" @click="addNewArticle(scope.row.id)" plain>新</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 编辑栏目 -->
    <el-dialog :title="openText" :visible.sync="openState" @close='closeDialog' width="600px" center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formLoading">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="所属栏目: " prop="parentName">
              <div class="m-article-box">
                <div v-for="(item, index) in dataListOpt" :key="index" :index="index" class="m-dialog-article-item"
                     :class="item['id'] === form.homeOptionId ? 'm-article-selected' : ''"
                     v-if="item['title'] !== '人气榜单' && item['title'] !== '创业医生'"
                     @click="loadSelectedData(item['id'])">
                  <div>{{ item['title'] }}</div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="标题: " prop="title">
              <el-input v-model="form.title" placeholder="输入标题"></el-input>
            </el-form-item>
            <el-form-item label="封面图: " prop="logo">
              <el-upload
                :action="uploadAction"
                :headers="myHeaders"
                accept=".jpg, .png"
                list-type="picture-card"
                :limit="1"
                :file-list="fileLists"
                :on-preview="handlePictureCardPreview"
                :on-success="success"
                :on-remove="handleRemove">
                <i class="el-icon-plus"></i>
              </el-upload>
              <!--大图弹出框-->
              <el-dialog width="400px" :visible.sync="imgDialogVisible" size="full" :modal="false" title="查看大图片">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
            <el-form-item label="报告价格: " prop="money">
              <el-input v-model="form.money" type="number" placeholder="输入报告价格"></el-input>
            </el-form-item>
            <el-form-item label="ios报告价格: " prop="iosMoney">
              <el-input v-model="form.iosMoney" type="number" placeholder="输入报告价格"></el-input>
            </el-form-item>
            <el-form-item label="活动虚价: " prop="falseMoney">
              <div style="position: relative;color: #ff4d51;">
                <div style="position: absolute; width: 50px; height: 1px; background-color: #ff4d51;top: 50%;left: 0;"></div>
                ￥{{ form.falseMoney }}
              </div>
              <el-input v-model="form.falseMoney" type="number" placeholder="输入活动虚价"></el-input>
            </el-form-item>
            <el-form-item label="ios活动虚价: " prop="iosFalseMoney">
              <div style="position: relative;color: #ff4d51;">
                <div style="position: absolute; width: 50px; height: 1px; background-color: #ff4d51;top: 50%;left: 0;"></div>
                ￥{{ form.iosFalseMoney }}
              </div>
              <el-input v-model="form.iosFalseMoney" type="number" placeholder="输入活动虚价"></el-input>
            </el-form-item>
            <el-form-item label="虚价开关: " prop="isFalseMoneyStatus">
              <el-switch v-model="isFalseMoneyStatus" active-text="开启" inactive-text="关闭"></el-switch>
            </el-form-item>
            <el-form-item label="说明: " prop="explain">
              <el-input v-model="form.explain" type="textarea" :rows="2" placeholder="输入说明"></el-input>
            </el-form-item>
            <el-form-item label="排序: " prop="sort">
              <el-input v-model="form.sort" type="number" placeholder="输入排序"></el-input>
            </el-form-item>
            <el-form-item label="设置状态: " prop="isStatus">
              <el-switch v-model="isStatus" active-text="上线" inactive-text="下线"></el-switch>
            </el-form-item>
            <el-form-item label="备注: " prop="remarks">
              <el-input v-model="form.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 内容编辑 -->
    <el-dialog width="600px" title="报告内容" :visible.sync="openAllContentState" @close='closeContentDialog' center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formContentLoading">
        <el-form :model="contentForm" ref="form" label-width="100px">
          <div class="m-table-title" style="margin: 0 0 10px 0;">
            <i class="el-icon-warning"></i>报告主内容
          </div>
          <div style="height: 500px">
            <quill-editor
              ref="myQuillEditor"
              class="editer"
              style="height: 400px"
              v-model="contentForm.content"
              :options="editorOption"
              @ready="onEditorReady($event)">
            </quill-editor>
          </div>
          <div class="m-table-title" style="margin: 0 0 10px 0;color: #4bb100">
            <i class="el-icon-warning-outline"></i>报告试读内容
          </div>
          <div style="height: 400px">
            <quill-editor
              ref="myQuillEditor"
              class="editer"
              style="height: 300px"
              v-model="contentForm.trialContent"
              :options="editorOption"
              @ready="onEditorReady($event)">
            </quill-editor>
          </div>
          <div style="margin-bottom: 30px">
            <div style="margin-bottom: 5px">备注：</div>
            <el-input v-model="contentForm.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
          </div>
          <div class="m-content-dialog-date">
            <div class="m-content-dialog-date-item">创建时间：{{contentForm.createDate}}</div>
            <div class="m-content-dialog-date-item" style="margin-left: 10px">更新时间：{{contentForm.updateDate}}</div>
          </div>
          <div style="text-align: center;">
            <el-button @click="openAllContentState = false">取 消</el-button>
            <el-button type="primary" @click="submitContent()">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 音频编辑 -->
    <el-dialog width="750px" title="音频" :visible.sync="openAudioState" @close='closeAudioDialog' center
               append-to-body :close-on-click-modal="false">
      <div class="m-open-container" v-loading="formAudioLoading">
        <el-form :model="audioForm" ref="audioForm" label-width="100px">
          <el-form-item label="主音频：">
            <UploadAudio
              :music-id="'music1'"
              v-if="openAudioState"
              v-on:maxTime="getAudioDuration"
              v-on:audioSuccess="audioSuccess"
              v-on:handleAudioRemove="handleAudioRemove"
              :action="'audios/audio-main/'"
              :accessKeys="accessKeys"
              :duration="audioForm.audioDuration"
              :nowAudioUrl="audioForm.audioPath !== '' ? audioForm.audioPath : ''"
            />
          </el-form-item>
          <el-form-item label="试听音频:" prop="trialAudioDuration">
            <UploadAudio
              :music-id="'music2'"
              v-if="openAudioState"
              v-on:maxTime="getAudioTrialDuration"
              v-on:audioSuccess="audioTrialSuccess"
              v-on:handleAudioRemove="handleTrialAudioRemove"
              :action="'audios/audio-small/'"
              :accessKeys="accessKeys"
              :duration="audioForm.trialAudioDuration"
              :nowAudioUrl="audioForm.trialAudioUrl !== '' ? audioForm.trialAudioUrl : ''"
            />
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="audioForm.remarks" type="textarea" :rows="2" placeholder="输入备注"></el-input>
          </el-form-item>
          <div class="m-content-dialog-date">
            <div class="m-content-dialog-date-item">创建时间：{{audioForm.createDate}}</div>
            <div class="m-content-dialog-date-item" style="margin-left: 10px">更新时间：{{audioForm.updateDate}}</div>
          </div>
          <div style="text-align: center;">
            <el-button @click="openAudioState = false">取 消</el-button>
            <el-button type="primary" @click="submitAudio()">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 编辑音频是否上架 -->
    <el-dialog width="750px" title="设置当前报告是否有音频" :visible.sync="audioStateDialog" @close='closeAudioStateDialog' center :close-on-click-modal="false">
      <div class="m-open-container" v-loading="audioStateLoading">
        <div style="text-align: center;padding: 40px;">
          <el-radio v-model="audioState" label="1" border>有音频</el-radio>
          <el-radio v-model="audioState" label="0" border>无音频</el-radio>
        </div>
        <div style="text-align: center;">
          <el-button @click="audioStateDialog = false">取 消</el-button>
          <el-button type="primary" @click="setAudioState()">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor'
import UploadAudio from '../public/UploadAudio'
export default {
  components: { // 使用编辑器
    quillEditor,
    UploadAudio
  },
  name: 'Article',
  data () {
    return {
      myHeaders: { Authorization: JSON.parse(window.sessionStorage.user).Authorization },
      uploadAction: '',
      dialogImageUrl: '',
      imgDialogVisible: false,
      audioStateDialog: false,
      audioStateLoading: false,
      audioState: '', // 是否有音频
      audioStateId: '',
      fileLists: [],
      accept: [],
      dataExtra: {},
      openText: '新增',
      openState: false,
      tree: false,
      formLoading: false,
      isLoading: true,
      isStatus: true,
      isFalseMoneyStatus: true,
      filterText: '',
      openAllContentState: false,
      formContentLoading: false,
      editorOption: {},
      dataList: [],
      dataListOpt: [],
      form: {
        id: '',
        homeOptionId: '',
        // homeOptionName: '',
        title: '',
        icon: '',
        money: '',
        iosMoney: '',
        falseMoney: '',
        iosFalseMoney: '',
        falseMoneyStatus: '',
        explain: '',
        sort: '',
        status: '1',
        remarks: ''
      },
      contentForm: {
        articleId: '',
        createDate: '',
        updateDate: '',
        content: '',
        trialContent: '',
        remarks: ''
      },
      contentType: '',
      openAudioState: false,
      formAudioLoading: false,
      audioFormTitle: '',
      audioStoragePath: '',
      audioForm: {
        articleId: '',
        audioPath: '',
        trialAudioUrl: '',
        audioDuration: 0,
        trialAudioDuration: 0,
        remarks: '',
        createDate: '',
        updateDate: ''
      },
      accessKeys: {
        accessKeyId: '',
        accessKeySecret: '',
        bucket: '',
        region: ''
      },
      newArticleList: [],
      rules: {
        homeOptionName: [
          { required: true, message: '请选择报告分类', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '请输入价格', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ],
        explain: [
          { required: true, message: '请输入报告说明', trigger: 'blur' }
        ],
        icon: [
          { required: true, message: '请上传封面图', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    // 赋值封面图上传路径
    this.uploadAction = this.$httpConf.baseURL + '/article/uploadImage'
  },
  // 初始化富文本
  editor () {
    return this.$refs.myQuillEditor.quill
  },
  methods: {
    addNewArticle (articleId) {
      let _this = this
      this.$messageBox.confirm('将当前项设置为‘最新报告’, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/articleNew/save', {articleId: articleId})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.loadNewArticleList()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    loadNewArticleList () {
      let _this = this
      this.isLoading = true
      _this.newArticleList = []
      this.$axios.post('/articleNew/list')
        .then((res) => {
          _this.newArticleList = res.data
          _this.isLoading = false
        })
    },
    newArticleDel (id) {
      let _this = this
      this.$messageBox.confirm('将永久删除当前项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/articleNew/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.loadNewArticleList()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 获取主音频时间
    getAudioDuration (e) {
      this.audioForm.audioDuration = Number(e.duration.toFixed(0))
    },
    // 获取试读音频时间
    getAudioTrialDuration (e) {
      this.audioForm.trialAudioDuration = Number(e.duration.toFixed(0))
    },
    // 删除主音频s
    handleAudioRemove (file, fileList) {
      this.audioForm.audioPath = ''
    },
    // 删除试读音频
    handleTrialAudioRemove (file, fileList) {
      this.audioForm.trialAudioUrl = ''
    },
    // 删除图片
    handleRemove (file, fileList) {
      this.form.icon = ''
      this.fileLists = []
    },
    // 查看大图
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.imgDialogVisible = true
    },
    // 图片上传成功
    success (response, file, fileList) {
      if (file.response.status === 200) {
        this.form.icon = file.response.data
        this.fileLists = [{url: this.$httpConf.ossURL + file.response.data}]
        this.dialogImageUrl = this.$httpConf.ossURL + file.response.data
        this.$message.success('上传成功')
      }
    },
    onEditorReady (editor) {
      console.log(editor)
    },
    // 清空文章内容弹窗
    closeContentDialog () {
      this.contentForm = {
        articleId: '',
        createDate: '',
        updateDate: '',
        content: '',
        trialContent: '',
        remarks: ''
      }
      this.contentType = ''
    },
    // 清空音频弹窗信息
    closeAudioDialog () {
      this.audioForm = {
        articleId: '',
        createDate: '',
        updateDate: '',
        audioPath: '',
        audioDuration: 0,
        trialAudioDuration: 0,
        trialAudioUrl: '',
        remarks: ''
      }
    },
    // 文章基本信息弹窗清空
    closeDialog () {
      // let id = this.form.homeOptionId
      this.form = {
        id: '',
        homeOptionId: this.form.homeOptionId,
        title: '',
        icon: '',
        money: '',
        iosMoney: '',
        falseMoney: '',
        iosFalseMoney: '',
        falseMoneyStatus: '',
        explain: '',
        sort: '',
        status: '1',
        remarks: ''
      }
      this.openText = '新增'
      this.formLoading = false
      this.filterText = ''
      this.fileLists = []
    },
    filterNode (value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    // 选择所属栏目
    selectMenu (e) {
      this.tree = false
      // this.form.homeOptionName = e.target.parentElement.name
      this.form.homeOptionId = e.target.parentElement.value
    },
    // 新增文章
    addArticle () {
      this.openState = true
    },
    // 提交文章基本信息
    submit () {
      let _this = this
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (_this.form.homeOptionId === '') {
            _this.$message.error('请选择所属分类！')
            return
          }
          _this.form.falseMoneyStatus = _this.isFalseMoneyStatus === true ? '1' : '0'
          _this.form.status = _this.isStatus === true ? '1' : '0'
          _this.formLoading = true
          this.$axios.post('/article/save', _this.form)
            .then((res) => {
              if (res.status === 200) {
                _this.$message.success(res.msg)
                _this.loadData()
                _this.openState = false
              } else {
                _this.$message.error(res.msg)
              }
              _this.formLoading = false
            })
        } else {
          return false
        }
      })
    },
    // 提交文章内容
    submitContent () {
      let _this = this
      let params = {
        articleId: _this.contentForm.articleId,
        content: _this.contentForm.content,
        trialContent: _this.contentForm.trialContent,
        remarks: _this.contentForm.remarks
      }
      this.formContentLoading = true
      this.$axios.post('/article/saveContent', params)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.loadData()
            this.openAllContentState = false
            this.formContentLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.formContentLoading = false
          }
        })
    },
    // 提交文章音频信息
    submitAudio () {
      let _this = this
      let params = {
        articleId: _this.audioForm.articleId,
        audioPath: _this.audioForm.audioPath,
        audioDuration: _this.audioForm.audioDuration,
        trialAudioDuration: _this.audioForm.trialAudioDuration,
        trialAudioUrl: _this.audioForm.trialAudioUrl,
        remarks: _this.audioForm.remarks
      }
      this.formAudioLoading = true
      this.$axios.post('/article/saveAudio', params)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.loadData()
            this.openAudioState = false
            this.formAudioLoading = false
          } else {
            _this.$message.error(res.msg)
            _this.formAudioLoading = false
          }
        })
    },
    // 打开设置音频状态弹窗
    openAudioStateDialog (id, state) {
      this.audioStateDialog = true
      this.audioState = state
      this.audioStateId = id
    },
    // 打开设置音频状态弹窗
    closeAudioStateDialog () {
      this.audioState = ''
      this.audioStateId = ''
    },
    // 设置当前报告音频状态0无音频1有音频
    setAudioState () {
      let _this = this
      this.audioStateLoading = true
      this.$axios.post('/article/saveAudioState', {articleId: _this.audioStateId, audioState: this.audioState})
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.loadData()
            this.audioStateDialog = false
          } else {
            _this.$message.error(res.msg)
          }
          _this.audioStateLoading = false
        })
    },
    // 删除当前文章
    menuDel (id, title) {
      let _this = this
      this.$messageBox.confirm('此操作将永久删除[' + title + '], 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post('/article/del', {id: id})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.loadData()
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    // 文章内容弹窗
    openArticleCont (id) {
      let _this = this
      this.openAllContentState = true
      this.formContentLoading = true
      this.$axios.post('/article/content', {id: id})
        .then((res) => {
          if (res.status === 200) {
            if (res.data != null) {
              this.contentForm = res.data
            }
            this.contentForm.articleId = id
            this.formContentLoading = false
          } else {
            this.contentForm.articleId = id
            _this.$message.error('您还未保存内容')
            this.formContentLoading = false
          }
        })
    },
    // 文章音频
    openArticleAudio (id) {
      let _this = this
      this.openAudioState = true
      this.formAudioLoading = true
      this.$axios.post('/article/audio', {id: id})
        .then((res) => {
          if (res.status === 200) {
            if (res.data != null) {
              this.audioForm = res.data
            } else {
              this.audioForm.articleId = id
            }
            this.formAudioLoading = false
          } else {
            this.audioForm.articleId = id
            _this.$message.error('查询失败')
            this.formAudioLoading = false
          }
        })
    },
    // 编辑报告基本信息
    openForm (id) {
      let _this = this
      this.openText = '编辑'
      this.formLoading = true
      this.openState = true
      this.$axios.post('/article/form', {id: id})
        .then((res) => {
          if (res.status === 200) {
            this.form = res.data
            this.isStatus = this.form.status === '1'
            this.isFalseMoneyStatus = this.form.falseMoneyStatus === '1'
            _this.fileLists = []
            if (res.data.icon !== undefined && res.data.icon !== '') {
              _this.fileLists = [{url: _this.$httpConf.ossURL + res.data.icon}]
            }
            this.formLoading = false
          } else {
            _this.$message.error(res.msg)
            this.formLoading = false
          }
        })
    },
    // 主音频上传成功
    audioSuccess (res) {
      this.audioForm.audioPath = res.url
    },
    // 试听音频上传成功
    audioTrialSuccess (res) {
      this.audioForm.trialAudioUrl = res.url
    },
    loadSelectedData (homeOptionId) {
      this.form.homeOptionId = homeOptionId
      this.loadData()
    },
    // 文章列表
    loadData () {
      let _this = this
      this.isLoading = true
      this.$axios.post('/article/list', {homeOptionId: _this.form.homeOptionId})
        .then((res) => {
          _this.dataList = res.data
          _this.isLoading = false
        })
    },
    // 获取栏目列表，默认选中第0个栏目
    homeOptionData () {
      let _this = this
      _this.dataListOpt = []
      this.$axios.post('/appHome/list')
        .then((res) => {
          _this.dataListOpt = res.data
          _this.form.homeOptionId = _this.dataListOpt[0].id
          _this.loadData()
        })
    },
    // 获取ossKey
    getUploadKey () {
      let _this = this
      this.isLoading = true
      this.$axios.post('/article/getUploadKey')
        .then((res) => {
          if (res.status === 200) {
            _this.accessKeys = res.data
          }
        })
    }
  },
  mounted () {
    this.homeOptionData()
    this.getUploadKey()
    this.loadNewArticleList()
  }
}
</script>

<style scoped src="../../assets/css/article.css"></style>



// WEBPACK FOOTER //
// src/components/article/Article.vue